import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";
import Overview from "./tabs/Overview";
import DailyPlan from "./tabs/DailyPlan";
import WeeklyPlan from "./tabs/WeeklyPlan";
import Supplements from "./tabs/Supplements";
import Vitamins from "./tabs/Vitamins";
import Checkin from "./tabs/Checkin";
import Cravings from "./tabs/Cravings";
import FoodLog from "./tabs/FoodLog";
import api from "../api";

const TABS = ["overview", "daily", "weekly", "supplements", "vitamins", "checkin", "cravings", "foodlog"];

// Fixed demo profile — football central midfielder, 28yo M
const DEMO_PROFILE = {
  sex: "M",
  age: 28,
  weight_kg: 78,
  height_cm: 182,
  sport: "football",
  position: "central_midfielder",
  activity_level: "performance",
  goal: "performance",
  special_conditions: [],
};

const Demo = () => {
  const { t } = useI18n();
  const [tab, setTab] = useState("overview");
  const [calc, setCalc] = useState(null);

  React.useEffect(() => {
    api.post("/calc/tdee", DEMO_PROFILE).then((r) => setCalc(r.data));
  }, []);

  if (!calc) return <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 text-white/60">{t.common.loading}</div>;

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-6">
      {/* Demo banner */}
      <div
        className="mb-6 p-4 flex flex-col md:flex-row items-start md:items-center justify-between gap-3"
        style={{ background: "#2A1A0F", border: "1px solid #F5A623" }}
        data-testid="demo-banner"
      >
        <div className="flex items-center gap-3">
          <span className="font-mono text-[10px] tracking-widest px-2 py-1" style={{ background: "#F5A623", color: "#0A0A0A" }}>
            DEMO
          </span>
          <span className="text-sm text-white/90">{t.dashboard.demo_banner}</span>
        </div>
        <Link to="/pricing">
          <button className="btn-primary" data-testid="demo-cta-buy">{t.dashboard.demo_cta}</button>
        </Link>
      </div>

      <div className="mb-8">
        <div className="font-mono text-xs tracking-widest text-[#FF3B30]">// DEMO PLAN</div>
        <h1 className="font-heading text-4xl md:text-5xl">
          FOOTBALL · CENTRAL MIDFIELDER
        </h1>
        <div className="mt-1 font-mono text-xs text-white/40">28 yo · 78 kg · 182 cm · Performance</div>
      </div>

      <div className="border-b mb-6 overflow-x-auto" style={{ borderColor: "#27272A" }}>
        <div className="flex gap-1 min-w-max">
          {TABS.map((tk) => (
            <button
              key={tk}
              data-testid={`demo-tab-${tk}`}
              onClick={() => setTab(tk)}
              className={`tab-btn ${tab === tk ? "active" : ""}`}
            >
              {t.dashboard.tabs[tk]}
            </button>
          ))}
        </div>
      </div>

      <div className="animate-fade-up">
        {tab === "overview" && <Overview profile={DEMO_PROFILE} calc={calc} />}
        {tab === "daily" && <DailyPlan profile={DEMO_PROFILE} />}
        {tab === "weekly" && <WeeklyPlan profile={DEMO_PROFILE} />}
        {tab === "supplements" && <Supplements profile={DEMO_PROFILE} />}
        {tab === "vitamins" && <Vitamins profile={DEMO_PROFILE} />}
        {tab === "checkin" && <Checkin profile={DEMO_PROFILE} />}
        {tab === "cravings" && <Cravings profile={DEMO_PROFILE} />}
        {tab === "foodlog" && <FoodLog profile={DEMO_PROFILE} demoMode={true} />}
      </div>

      <div className="mt-10 p-6 text-center" style={{ background: "#181111", border: "1px solid #FF3B30" }}>
        <h3 className="font-heading text-2xl mb-2">Ready to build YOUR plan?</h3>
        <p className="text-white/70 mb-4">Save it, regenerate up to 10× (€50) or 25× (€100), export to PDF.</p>
        <Link to="/pricing">
          <button className="btn-primary" data-testid="demo-bottom-cta">Get Access →</button>
        </Link>
      </div>
    </div>
  );
};

export default Demo;
